import { createApp, watch } from 'vue';
import App from './App.vue';
import { createI18n } from 'vue-i18n';
import './assets/tailwind.css';
import en from './locales/en.json';
import ar from './locales/ar.json';
import locale from './locale'; 
import GTag from 'vue-gtag';

const app = createApp(App);

app.use(GTag, {
  property: {
    id: 'G-7L5E0BLP2Q',
  },
});

const messages = {
  en,
  ar,
};

function getLanguageFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get('lang');
}

const initialLocale = getLanguageFromUrl() || 'en';
locale.setLocale(initialLocale); 

const i18n = createI18n({
  locale: locale.state.locale, 
  messages,
});

app.use(i18n);

watch(() => locale.state.locale, (newLocale) => {
  i18n.global.locale.value = newLocale;
});

app.mount('#app');
